export default {
  dataIterator: {
    rowsPerPageText: 'Pozycji na stronie:',
    rowsPerPageAll: 'Wszystkie',
    pageText: '{0}-{1} z {2}',
    noResultsText: 'Nie znaleziono danych',
    nextPage: 'Następna strona',
    prevPage: 'Poprzednia strona'
  },
  dataTable: {
    rowsPerPageText: 'Wierszy na stronie:'
  },
  noDataText: 'Brak danych',
  carousel: {
    prev: 'Poprzedni obraz',
    next: 'Następny obraz'
  }
}
